import { render, staticRenderFns } from "./IOTab.vue?vue&type=template&id=a4212f6a&scoped=true&"
import script from "./IOTab.vue?vue&type=script&lang=ts&"
export * from "./IOTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4212f6a",
  null
  
)

export default component.exports